import { render, staticRenderFns } from "./plattask-info.vue?vue&type=template&id=21198bff&"
import script from "./plattask-info.vue?vue&type=script&lang=js&"
export * from "./plattask-info.vue?vue&type=script&lang=js&"
import style0 from "./plattask-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports